import { Flow_0_0_2 } from '@flexus/core';

export const SIL_25: Flow_0_0_2 = {
	id: '25',
	name: 'work_stopped_invalid_claim',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for SP to invoice call out fee'
		}
	},
	startNode: '',
	nodes: {}
};
